import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/hero-home-section/components/HeroInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/hero-home-section/components/PageLoaderWrapper.tsx");
